export const FEATURE_DECORATION_BG_CLASSES = [
  'before:bg-feature-1',
  'before:bg-feature-2',
  'before:bg-feature-3',
  'before:bg-feature-4',
];

export const FEATURE_COVER_BG_CLASSES = [
  'bg-feature-1',
  'bg-feature-2',
  'bg-feature-3',
  'bg-feature-4',
];

export const FEATURE_VIDEO_CLASSES = [
  'top-0 left-6',
  'top-4 left-2',
  '-top-4 -left-2',
  'top-0 -left-6',
];
